module.exports = __webpack_public_path__ + "static/media/question.a34573f5.svg";